import { RuleFormType } from './components/rule-form/types'

export const getCurrentModifier = (
	modifiers: RuleFormType['modifiers'],
	criteriaType: string
) => modifiers.find((m) => m.type === criteriaType)
